import { getResourcesUrl } from '@cartwhl/common/utils';

export const AXEL_CHARACTER_ID = 'char-upload-Axel';
export const MHR_CHARACTER_ID = 'char-upload-MHR';

const BUILTIN_FREE_CHARACTER_IDS = new Set([
  AXEL_CHARACTER_ID,
  MHR_CHARACTER_ID,
]);

/** MHR is stored as `original.glb`; other built-in free characters use `character.glb`. */
const MESH_FILENAMES: Partial<Record<string, string>> = {
  [MHR_CHARACTER_ID]: 'original.glb',
};

export function stripCharacterIdInstanceSuffix(characterID: string): string {
  return characterID.replace(/_\d+$/, '');
}

export function isBuiltinFreeCharacterId(characterID: string): boolean {
  return BUILTIN_FREE_CHARACTER_IDS.has(
    stripCharacterIdInstanceSuffix(characterID),
  );
}

export function isMhrCharacterId(characterID: string): boolean {
  return stripCharacterIdInstanceSuffix(characterID) === MHR_CHARACTER_ID;
}

export function getBuiltinFreeCharacterMeshPath(
  characterID: string,
): string | null {
  const baseID = stripCharacterIdInstanceSuffix(characterID);
  if (!BUILTIN_FREE_CHARACTER_IDS.has(baseID)) {
    return null;
  }

  const resourcesBase = getResourcesUrl(false).replace(/\/share$/, '');
  const meshFilename = MESH_FILENAMES[baseID] ?? 'character.glb';
  return `${resourcesBase}/character-uploads/FREE_CHARACTERS/${baseID}/${meshFilename}`;
}
